import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "@emotion/styled-base";
var _excluded = ["name", "value", "options", "disabled", "size", "onChange", "variant"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from 'react';
import PropTypes from 'prop-types';
import Flex from "../Flex";
import ButtonGroupOption from "./ButtonGroupOption"; // Setting a transform here creates a stacking context, so the we can use z-index
// in ButtonGroupOption without worrying about z-index conflicts with other components

var ButtonGroupWrapper = /*#__PURE__*/_styled(Flex, {
  target: "e11kecp80",
  label: "ButtonGroupWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "41q668",
  styles: "transform:scale(1);"
} : {
  name: "41q668",
  styles: "transform:scale(1);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var ButtonGroup = function ButtonGroup(_ref) {
  var name = _ref.name,
      value = _ref.value,
      options = _ref.options,
      disabled = _ref.disabled,
      size = _ref.size,
      onChange = _ref.onChange,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ButtonGroupWrapper, _extends({
    role: "radiogroup",
    "aria-label": name
  }, rest), options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(ButtonGroupOption, {
      key: index,
      id: "buttonGroup_".concat(name, "_").concat(index),
      name: name,
      label: option.label,
      value: option.value,
      checked: option.value === value,
      disabled: disabled,
      size: size,
      totalOptions: options.length,
      onChange: onChange,
      variant: variant
    });
  }));
};

ButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
  variant: PropTypes.string
};
ButtonGroup.defaultProps = {
  disabled: false,
  size: 'base',
  variant: 'default'
};
export default ButtonGroup;